import { gql } from "@apollo/client";

export default gql`
  mutation addWorkerTags($workerId: ID!, $tags: [String!]!) {
    addWorkerTags(workerId: $workerId, tags: $tags) {
      id
    }
  }
`;
